/* istanbul ignore file */
import _ from 'lodash'
import numeral from 'numeral'
import { enums } from '@adc/sdk'
import * as blueprint from '@adc/blueprint'
import { formatters } from '../../../utils'
import { isPrivateSeller } from '../badges/definitions/utils'

export const MISSING_VALUE_LABEL = 'TBD'

export const isForeclosure = listing =>
  ['TRUSTEE', 'FCL_MARKETING'].includes(
    listing.listing_configuration?.product_type
  )

export const getERV = listing => listing.primary_property?.summary?.valuation

// TODO: verify with platform on this
export const valuationEstimate = listing => {
  const valuation = getERV(listing)
  return valuation ? numeral(valuation).format('$0,0') : ''
}

export const getOpeningBidValue = listing => {
  const showOpeningBid = _.get(listing, 'listing_summary.show_opening_bid')

  return showOpeningBid
    ? formatters.formatMoney(listing.auction.starting_bid, null, true)
    : MISSING_VALUE_LABEL
}

export const LISTING_CARD_PHOTO_WIDTH = 282

export const getAddressLine = (address = {}, displayCounty = false) => {
  const streetNumber = address.street_number || ''
  const streetName = address.street_name || ''
  return `${streetNumber} ${streetName} ${address.municipality || ''}, ${
    address.country_primary_subdivision || ''
  } ${address.postal_code || ''}${
    displayCounty && address.country_secondary_subdivision
      ? `, ${address.country_secondary_subdivision}`
      : ''
  }`
}

export const getDisplayedValue = listing => {
  if (blueprint.listing.utils.shouldDisplayListPrice(listing)) {
    return {
      label: 'List Price',
      amount: formatters.formatMoney(
        listing.valuation?.seller_current_value_amount,
        null,
        true
      ),
    }
  }
  if (shouldDisplayCurrentBid(listing)) {
    return {
      label: 'Current Bid',
      amount: formatters.formatMoney(getCurrentBid(listing), null, true),
    }
  }
  if (isForeclosure(listing)) {
    if (listing.reserve_price) {
      return {
        label: 'Credit Bid',
        amount: formatters.formatMoney(listing.reserve_price, null, true),
      }
    } else {
      if (listing.auction?.starting_bid) {
        return {
          label: 'Opening Bid',
          amount: getOpeningBidValue(listing),
        }
      } else {
        return {
          label: 'Opening Bid',
          amount: MISSING_VALUE_LABEL,
        }
      }
    }
  } else {
    if (listing.auction?.starting_bid) {
      return {
        label: 'Opening Bid',
        amount: getOpeningBidValue(listing),
      }
    } else {
      return {
        label: 'Opening Bid',
        amount: MISSING_VALUE_LABEL,
      }
    }
  }
}

export const getIsReserveMet = listing => {
  const { online_auction_segment } = listing

  return (
    online_auction_segment?.reserve_status === enums.ReserveStatus.ReserveMet
  )
}

const isListingSoldOrPending = listing =>
  [enums.ListingStatusGroup.Pending, enums.ListingStatusGroup.Sold].includes(
    listing.listing_status_group
  )
export const shouldDisplayCurrentBid = listing =>
  !isListingSoldOrPending(listing) && !!getCurrentBid(listing)

export const getCurrentBid = listing =>
  listing?.online_auction_segment?.current_highest_bid?.bid_amount ||
  listing?.live_auction_segment?.current_highest_bid?.bid_amount

export const shouldDisplayReserveMet = listing => {
  return (
    !isListingSoldOrPending(listing) &&
    getIsReserveMet(listing) &&
    !isPrivateSeller(listing)
  )
}

/**
 * This is needed to allow HTML stored in a string to correctly be injected for the
 * adglareHtmlOverride use-case. Soln taken from: https://stackoverflow.com/questions/54184371/react-dangerouslysetinnerhtml-not-working-when-using-variable
 */
export const htmlDecode = content => {
  const e = document.createElement('div')
  e.innerHTML = content
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
}
